export enum monthlyPartsSummaryActions {
  GET_MONTHLY_PARTS_SUMMARY_LOADING = "@@monthlypartssummary/GET_MONTHLY_PARTS_SUMMARY_LOADING",
  GET_MONTHLY_PARTS_SUMMARY_SUCCESS = "@@monthlypartssummary/GET_MONTHLY_PARTS_SUMMARY_SUCCESS",
  GET_MONTHLY_PARTS_SUMMARY_ERROR = "@@monthlypartssummary/GET_MONTHLY_PARTS_SUMMARY_ERROR",
}